<template>
  <v-card>
    <v-container class="py-0">
      <v-card-title class="text-h5 mt-2 px-0">
        <v-row class="py-0">
          <v-col class="pt-1 pb-0">
            <v-card-actions class="px-0 py-0">
              <v-spacer></v-spacer>
              <v-tooltip location="left">
                <template v-slot:activator="{ props }">
                  <v-btn
                    color="primary"
                    @click="closeDialog"
                    :icon="closeIcon"
                    variant="text"
                    v-bind="props"
                    id="v-btn-close-envio-financiador"
                  >
                  </v-btn>
                </template>
                Cerrar
              </v-tooltip>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-2 pt-0">
            Seleccionar financiador para envío de credenciales
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="px-0 pt-3">
        <v-autocomplete
          v-model="selectedFinanciador"
          :items="financiadores"
          item-title="value1"
          item-value="id"
          label="Seleccionar financiador"
          return-object
          clearable
          variant="outlined"
          :loading="isLoadingFinanciadores"
          id="v-autocomplete-financiador"
        >
        </v-autocomplete>

        <v-card-actions class="justify-end pr-0 mt-3">
          <v-btn
            color="primary"
            @click="confirmarEnvio"
            :disabled="!selectedFinanciador"
            id="v-btn-enviar-credenciales-financiador"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-container>

    <!-- Dialog de confirmación -->
    <v-dialog
      v-if="dialogConfirmEnvio"
      v-model="dialogConfirmEnvio"
      :max-width="isMobile ? '95%' : '55%'"
      persistent
    >
      <ConfirmDialog
        title="¿Desea continuar con el envío masivo de credenciales a TODOS los usuarios correspondientes al financiador?"
        :isLoading="isLoadingEnvio"
        @confirmar="confirmEnvioPorFinanciador"
        @confirmar-cancelado="closeConfirmDialog"
      />
    </v-dialog>

    <!-- Dialog de exportación de errores -->
    <v-dialog
      v-if="dialogConfirmExportErrors"
      v-model="dialogConfirmExportErrors"
      :max-width="isMobile ? '95%' : '40%'"
      persistent
    >
      <ConfirmDialog
        title="¿Desea exportar a Excel los usuarios que tuvieron errores en el envío de credenciales?"
        :isLoading="isLoadingExportErrors"
        @confirmar="exportErrors"
        @confirmar-cancelado="closeDialogConfirmExportErrors"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import enums from "@/utils/enums/index";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import helpersExcel from "@/utils/helpers/importExportExcel.js";

export default {
  name: "SeleccionarFinanciadorEnvioCredenciales",
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      selectedFinanciador: null,
      closeIcon: enums.icons.CLOSE_ICON,
      financiadores: [],
      isLoadingFinanciadores: false,
      dialogConfirmEnvio: false,
      isLoadingEnvio: false,
      usuariosConError: [],
      dialogConfirmExportErrors: false,
      isLoadingExportErrors: false,
      userLoggedType: null,
    };
  },
  computed: {
    ...mapGetters({ isMobile: "menu/isMobile", userName: "logIn/userName" }),
  },
  async created() {
    await this.loadFinanciadores();
  },
  methods: {
    ...mapActions({
      getFinanciadores: "taxonomy/getFinanciadores",
      enviarCredencialesPorFinanciador:
        "financiador/enviarCredencialesPorFinanciador",
      setAlert: "user/setAlert",
    }),
    async loadFinanciadores() {
      this.isLoadingFinanciadores = true;
      try {
        this.financiadores = await this.getFinanciadores();
      } catch (error) {
        console.error("Error al cargar financiadores:", error);
      }
      this.isLoadingFinanciadores = false;
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    confirmarEnvio() {
      this.dialogConfirmEnvio = true;
    },
    closeConfirmDialog() {
      this.dialogConfirmEnvio = false;
    },
    async confirmEnvioPorFinanciador() {
      this.isLoadingEnvio = true;
      try {
        const response = await this.enviarCredencialesPorFinanciador(
          this.selectedFinanciador.id
        );

        // Verificar si hay usuarios con errores
        const usuariosConError = response.filter((usuario) => !usuario.enviado);
        const usuariosExitosos = response.filter((usuario) => usuario.enviado);

        if (usuariosConError.length > 0) {
          // Hay errores - mostrar mensaje y ofrecer exportar
          this.usuariosConError = usuariosConError;
          this.setAlert({
            type: "warning",
            message: `Credenciales enviadas a ${usuariosExitosos.length} usuarios. ${usuariosConError.length} usuarios tuvieron errores.`,
          });
          this.closeConfirmDialog();
          this.dialogConfirmExportErrors = true;
        } else {
          // Todo exitoso
          this.setAlert({
            type: "success",
            message: `Credenciales enviadas exitosamente a ${response.length} usuarios.`,
          });
          this.closeConfirmDialog();

          this.closeDialog();
        }
      } catch (error) {
        this.setAlert({
          type: "error",
          message: `${error.response.data.errors}`,
        });
        console.error("Error al enviar credenciales:", error);
        this.closeConfirmDialog();
      }
      this.isLoadingEnvio = false;
    },
    async exportErrors() {
      this.isLoadingExportErrors = true;
      try {
        // Obtener información detallada de los usuarios con error
        let result = [];
        for (const usuarioError of this.usuariosConError) {
          result.push({
            ["Usuario ID"]: usuarioError.usuarioId || "",
            ["Nombre de usuario"]: usuarioError.userName || "",
            ["Email"]: usuarioError.email || "Sin email",
            ["Motivo del error"]: usuarioError.email
              ? "Error en el servicio de email"
              : "Usuario sin email",
          });
        }

        let formato = {
          filas: result,
          hoja: "Errores envío credenciales",
        };

        helpersExcel.excelExport(formato, "Errores envío credenciales");

        this.setAlert({
          type: "success",
          message: "Usuarios con errores exportados con éxito.",
        });
      } catch (error) {
        this.setAlert({
          type: "error",
          message: "Error al exportar usuarios con errores.",
        });
        console.error("Error al exportar usuarios con errores:", error);
      }
      this.isLoadingExportErrors = false;
      this.closeDialogConfirmExportErrors();
    },
    closeDialogConfirmExportErrors() {
      this.dialogConfirmExportErrors = false;
      this.usuariosConError = [];

      // Después de manejar los errores, cerrar el componente completo
      this.closeDialog();
    },
  },
};
</script>

<style scoped></style>